import request from '@/utils/request'

export function page(data) {
  return request({
    url: '/mg/mg-waimai-api/takeoutOrder/page',
    method: 'post',
    data,
  })
}

export function detail(id) {
  return request({
    url: `/mg/mg-waimai-api/takeoutOrder/${id}`,
    method: 'get',
  })
}

export function summary(data) {
  return request({
    url: '/mg/mg-waimai-api/takeoutOrder/sum',
    method: 'post',
    data,
  })
}

export function linkSystemProducts(data) {
  return request({
    url: '/mg/mg-waimai-api/takeoutOrderLinkedSystemItem',
    method: 'put',
    data,
    loading: true,
  })
}

export function conversionCashier(id) {
  return request({
    url: `/mg/mg-waimai-api/takeoutOrder/convertRetailSaleOrder/${id}`,
    method: 'get',
    loading: true,
  })
}
//待打印外卖订单列表
export function getPrintList(data) {
  return request({
    url: `/mg/mg-waimai-api/takeoutOrder/getPrint`,
    method: 'post',
    data,
  })
}
//更新打印
export function updatePrint(data) {
  return request({
    url: `/mg/mg-waimai-api/takeoutOrder/updatePrint`,
    method: 'post',
    data,
  })
}

/**
 * 接单
 * @param {*} id 外卖订单
 * @returns
 */
export function takeOrder(id) {
  return request({
    url: `/mg/mg-waimai-api/takeoutOrder/accept/${id}`,
    method: 'get',
    loading: true,
  })
}


/**
 * (饿了么-京东)完成拣货
 * @param {*} id 外卖订单
 * @returns
 */
export function completePickup(id) {
  return request({
    url: `/mg/mg-waimai-api/takeoutOrder/completePickup/${id}`,
    method: 'get',
    loading: true,
  })
}



/**
 * 查询当天各外卖平台订单数量
 * @returns
 */
export function countTodayPlatform() {
  return request({
    url: `/mg/mg-waimai-api/takeoutOrder/countTodayPlatform`,
    method: 'get',
    allowRepeat: true,
  })
}

/**
 * 查询库位信息
 * @param {*} data 查询参数
 * @returns
 */
export function getWarehouseLocationList(data) {
  return request({
    url: '/mg/daohang-stock-api/warehouseLocation/retail/list',
    method: 'post',
    data,
  })
}

/**
 * 外卖订单关联商品查平台库存
 * @param {*} data 查询参数
 * @returns
 */
export function queryPlatformStock(data) {
  return request({
    url: '/mg/daohang-product-api/waiMaiProductMapping/groupList',
    method: 'post',
    data: {...data, t: new Date().getTime() },
    loading: true,
  })
}


//查询当前用户是否开通 会员小程序
export function checkUserEnableMemberMiniProgram() {
  return request({
    url: '/mg/daohang-order-api/common/ifOnlineMemberMiniProgram',
    method: 'get',
    loading: true,
  })
}


